import React from 'react';

interface DelayIconProps {
  angle?: number;
  size?: number;
  className?: string;
}

export const DelayIcon: React.FC<DelayIconProps> = ({
  angle = 0,
  size = 24,
  className,
}) => {
  // Center of the circle is at (69, 52.85) based on the viewBox
  const centerX = 69;
  const centerY = 52.85;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="delay"
      viewBox="59 42.85 20 20"
      width={size}
      height={size}
      className={className}
    >
      <defs>
        <style>
          {`
            .cls-1 {
              fill: none;
              stroke: #fff;
              stroke-linecap: round;
              stroke-miterlimit: 10;
              stroke-width: 1.07px;
            }

            .cls-2 {
              fill: #fff;
            }

            .cls-3 {
              fill: #47a;
            }
          `}
        </style>
      </defs>
      <g>
        <path
          className="cls-3"
          d="M69,62.35c-5.24,0-9.5-4.26-9.5-9.5s4.26-9.5,9.5-9.5,9.5,4.26,9.5,9.5-4.26,9.5-9.5,9.5Z"
        />
        <path
          className="cls-2"
          d="M69,43.85c4.96,0,9,4.04,9,9s-4.04,9-9,9-9-4.04-9-9,4.04-9,9-9M69,42.85c-5.52,0-10,4.48-10,10s4.48,10,10,10,10-4.48,10-10-4.48-10-10-10h0Z"
        />
      </g>
      <g>
        <path
          className="cls-2"
          d="M68.94,59.85c3.68,0,6.73-3.09,6.73-6.82,0-1.56-.53-3-1.43-4.16l.51-.53c.15-.15.24-.36.24-.54,0-.37-.3-.68-.68-.68-.22,0-.38.07-.54.22l-.5.5c-1.01-.87-2.26-1.45-3.64-1.6v-.66c0-.4-.32-.74-.71-.74s-.71.33-.71.74v.66c-3.35.37-6.01,3.3-6.01,6.78,0,3.73,3.05,6.82,6.73,6.82Z"
        />
        <line className="cls-1" x1="66.8" y1="45.38" x2="71.09" y2="45.38" />
      </g>
      <g transform={`rotate(${angle} ${centerX} ${centerY})`}>
        <polygon
          className="cls-3"
          points="68.79 46.92 65.57 48.69 72.01 48.69 68.79 46.92"
        />
      </g>
    </svg>
  );
};

export default DelayIcon;
